import { axiosInstance, API_PREFIX, type ApiResponse } from '@/shared/api';

export const deleteFile = async (id: number | string): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${API_PREFIX.ADMIN_V1}/file/delete`, { id });
  return data;
};
